var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ElContainer',{staticClass:"page-container",attrs:{"direction":"vertical"}},[_c('VcHeader'),_c('ElContainer',{staticClass:"overflow-hidden"},[_c('VcAside'),_c('VcMain',{staticClass:"scrollbar"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }